// @ts-nocheck
/* eslint-disable */
/* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */
import { ReactComponent as ArrowNarrowRightDefault } from '../../../assets/icons/default/arrows/arrow-narrow-right.svg?react';
import { ReactComponent as ArrowNarrowRightSolid } from '../../../assets/icons/solid/arrows/ARROW-NARROW-RIGHT.svg?react';
import { createIcons } from '../../Icon';
const ArrowNarrowRightIcon = /* @__PURE__ */ createIcons('ArrowNarrowRight', {
    default: ArrowNarrowRightDefault,
    solid: ArrowNarrowRightSolid
});
ArrowNarrowRightIcon.supportedTypes = ['default', 'solid'];
ArrowNarrowRightIcon.category = 'arrows';
export default ArrowNarrowRightIcon;
